// ESM-Huelle fuer lib/scripts/components/CMP_CInputField.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CInputField (id)
{
    this.construct (id);

    this.name = "CInputField";
    this.htmlType = "div";
    
    this.properties =
    {
        backspace:
        {
            show: false,
            caption: {},
	    class: "backbutton", 
            styles:
            {
            }
        },
        clear:
        {
            show: false,
            caption:
            {
                value: "C",
                styles:
                {
                }
            },
		class: "clearbutton",
            styles:
            {
            }
        },
        input:
        {
            type: "all",
            styles:
            {
            }
        },
        styles:
        {
           // width: "200px"
        }
    }
    
    this.container = null;
    this.input = null;
    this.backspace = null;
    this.clear = null;
}

CInputField.prototype = new CComponent;

CInputField.prototype.prepare = function ()
{
    this.container = this.addChild (CContainerTable);
    this.container.properties.rows = 1;
    this.container.properties.columns = 1;
    
    var buttons = 0;
    
    if (this.properties.backspace.show)
    {
        buttons++;
        this.container.properties.columns++;
    }
    if (this.properties.clear.show)
    {
        buttons++;
        this.container.properties.columns++;
    }
    
    this.container.prepare ();

    this.input = this.container.body.rows[0].columns[0].addChild (CInput);
    this.input.properties = combine (this.input.properties, this.properties.input);
   // this.input.properties.styles.width = (parseFloat(this.properties.styles.width) - buttons * 40 - 8 - 35) + "px";
        this.container.body.rows[0].columns[0].properties.styles.width =
            this.input.properties.styles.width;
	
    var col = 1;

    if (this.properties.backspace.show)
    {
        this.backspace = this.container.body.rows[0].columns[col].addChild (CPushButton);
        this.backspace.properties = combine (this.backspace.properties, this.properties.backspace);
        this.backspace.properties.events.onClick = this.gotBackspace;
        this.backspace.properties.attributes.onClick_parameter_0 = this.input.id;
        col++;
    }
    
    if (this.properties.clear.show)
    {
        this.clear = this.container.body.rows[0].columns[col].addChild (CPushButton);
        this.clear.properties = combine (this.clear.properties, this.properties.clear);
        this.clear.properties.events.onClick = this.gotClear;
        this.clear.properties.attributes.onClick_parameter_0 = this.input.id;
        col++;
    }
    
    this.prepared = true;
}

CInputField.prototype.gotBackspace = function (component, parameters)
{
    var comp = POS.getComponentById (parameters[0]);
    comp.setFocus();
    comp.gotBackspace ();
}

CInputField.prototype.gotClear = function (component, parameters)
{
    var comp = POS.getComponentById (parameters[0]);
    comp.setFocus();
    comp.gotClear ();
}

CInputField.prototype.setEnabled = function(bool)
{
    this.backspace.setEnabled(bool);
    this.clear.setEnabled(bool);
}

export { CInputField };
